"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createTapEncryptedFrame(id, payload, paddingGenerator) {
    var len = payload.length;
    // let padSize = Util.computePadding(8 + len, 16)
    // let padding = paddingGenerator ? paddingGenerator(padSize) : undefined
    return {
        id: id,
        len: len,
        payload: payload,
    };
}
exports.createTapEncryptedFrame = createTapEncryptedFrame;
